// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sen-styles-chartWrapper-AmmtnTlX{margin-top:24px;margin-right:24px;margin-bottom:24px}`, "",{"version":3,"sources":["webpack://./src/components/Spaces/CountsChart/styles.scss"],"names":[],"mappings":"AAAA,kCACE,eAAA,CACA,iBAAA,CACA,kBAAA","sourcesContent":[".chartWrapper {\n  margin-top: 24px;\n  margin-right: 24px;\n  margin-bottom: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartWrapper": `sen-styles-chartWrapper-AmmtnTlX`
};
export default ___CSS_LOADER_EXPORT___;
